import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Pending status icon — clock face with two hands.
 *
 * Dual-tone layered style:
 * - Clock face circle: cyan accent fill at 8%, currentColor outline
 * - Clock hands (one vertical, one horizontal): currentColor stroke
 *
 * Used for queued / pending pipeline states.
 */
export const PendingIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size} fill="none">
    {/* Clock face — cyan accent fill at 8% */}
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
    />
    {/* Vertical hand — from center up to 12 o'clock */}
    <path
      d="M 12 12 L 12 7"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Horizontal hand — from center to 3 o'clock */}
    <path
      d="M 12 12 L 16 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

PendingIcon.displayName = "PendingIcon";

export default PendingIcon;
